import { render } from "./MainHeroSlide.vue?vue&type=template&id=de13d812&scoped=true"
import script from "./MainHeroSlide.vue?vue&type=script&lang=js"
export * from "./MainHeroSlide.vue?vue&type=script&lang=js"

import "./MainHeroSlide.vue?vue&type=style&index=0&id=de13d812&scoped=true&lang=css"

import exportComponent from "/Users/alekseisemiguk/Documents/sadko/35FIT-full/35FIT/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de13d812"]])

export default __exports__